class Resource {
    id;
    type;
    resourceId;
    instanceId;
    states;

    constructor({id, instanceId, type, resourceId}) {
        this.id = id;
        this.instanceId = instanceId;
        this.type = type;
        this.resourceId = resourceId;
        this.states = [];
    }

    async load() {
        throw new Error("subclass responsibility");
    }

    prepareState(state) {
        this.states.push(state);
    }

    loadState(options = {}) {
        const state = options.patchState && this.type !== "InformationTag" ? this.mergeStates({}) : this.mergeStates(this.getDefaultState());
        this.setState(state, options);
        this.states = [];
    }

    getDefaultState() {
        throw new Error("subclass responsibility");
    }

    setState(state, options) {
        //do nothing by default
    }

    mergeStates(initialState) {
        let finalState = initialState;
        for(let i = 0; i < this.states.length; i++) {
            finalState = {...finalState, ...this.states[i]};
        }
        return finalState;
    }

    compareStates(startStates, endStates) {
        return endStates;
    }

    decompose(state, appendState) {
        if (!state || !state.length) {
            return [];
        }

        return [{
            startTime: 0,
            actionId: generateUUID(),
            type: "LoadState",
            appendState: appendState,
            loadViewpoint: false,
            patchState: false,
            states: [{
                resourceStates: state
            }]
        }]
    }

    async getSizeHint() {
        return 1; //TODO: will be included in other resources for continuous progressbar
    }

    onLoad(training, deltaLoaded) {
        const newProgress = wv.trainingSplashScreen.getCurrentProgress() + (deltaLoaded * 100) / training.getTotalSizeHint();
        wv.trainingSplashScreen.setProgress(newProgress);
    }
}

export default Resource;
